import { z } from 'zod';

export const MessageTemplateDtoSchema = z.object({
    id: z.string(),
    name: z.string(),
});

export type MessageTemplateDto = z.infer<typeof MessageTemplateDtoSchema>;
